import * as constants from "./constants";
export const initialState = {
    //Logs
    isLoading: false,
    data: [],
    error: null
};
const logsReducer = (state = initialState, action)=> {
    switch (action.type) {
        case constants.LOGS_LIST_REQUESTING:
        case constants.PAGINATE_LOGS_LIST_REQUESTING:
            return {
                ...state,
                isLoading:true
            };

        case constants.LOGS_LIST_SUCCESS:
        case constants.PAGINATE_LOGS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action?.payload,
                error: null,
            };

        case constants.LOGS_LIST_FAILED:
        case constants.PAGINATE_LOGS_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                data: [],
                error: action.error,
            };


        default:
            return state;
    }
}
export default logsReducer
